'use strict';
const { EVENT_KEY_ESC } = require('../constants');
const { queryFirst, queryAll, addClass, hasClass, removeClass, matchesBreakpoint } = require('../domUtil');
const breakpoints = require('../constants');
const { syncCollapsedFiltersA11y } = require('../helpers/searchHelper');

const hideClass = 'hidden-filters';
const refinementBar = queryFirst('.refinement-bar');
const searchContainerEl = queryFirst('.search-results-container');
const filterPanel = queryFirst('.filter-sticky-panel');
const hideBtn = queryFirst('.hide-filter-btn', filterPanel);
let windowWidth = window.innerWidth;
let refinementsEl = queryFirst('.refinements');
let clearBtn = queryFirst('.js-clear-filters-btn', filterPanel);

const toggleFilterDisplay = () => {
    if (!matchesBreakpoint('md')) {
        return;
    }

    if (searchContainerEl && hasClass(searchContainerEl, hideClass)) {
        removeClass(searchContainerEl, hideClass);
        hideBtn.setAttribute('aria-expanded', 'true');
        refinementBar.removeAttribute('tabindex');
        syncCollapsedFiltersA11y();
        $(hideBtn).trigger('toggle.lp.filters', 'filter menu: show');

        return;
    }

    addClass(searchContainerEl, hideClass);
    hideBtn.setAttribute('aria-expanded', 'false');
    searchContainerEl.setAttribute('tabindex', '-1');
    syncCollapsedFiltersA11y();
    $(hideBtn).trigger('toggle.lp.filters', 'filter menu: hide');
    hideBtn.focus();
};

module.exports = () => {
    syncCollapsedFiltersA11y();

    if (hideBtn) {
        hideBtn.addEventListener('click', toggleFilterDisplay);
    }

    document.addEventListener('keydown', e => {
        if (e.key !== EVENT_KEY_ESC) {
            return;
        }

        if (queryFirst('.modal.show')) {
            return;
        }

        if (windowWidth < breakpoints.md) {
            return;
        }

        if (!searchContainerEl || hasClass(searchContainerEl, hideClass)) {
            return;
        }

        addClass(searchContainerEl, hideClass);
        hideBtn.setAttribute('aria-expanded', 'false');
        syncCollapsedFiltersA11y();
        hideBtn.focus();
    });

    $('body').on('search:updateProducts', function () {
        refinementsEl = queryFirst('.refinements');
        clearBtn = queryFirst('.js-clear-filters-btn', filterPanel);
        syncCollapsedFiltersA11y();
    });

    // Add event listener to .js-refinement-content element btn on shown.bs.collapse event
    // to scroll refinement to show the refinement filter values when accordion is expanded
    $(refinementsEl).on('shown.bs.collapse', '.js-refinement-content', e => {
        const child = e.currentTarget.parentNode;
        const container = queryFirst('.refinement-menu');
        const containerTop = container.getBoundingClientRect().top;
        const childTop = child.getBoundingClientRect().top;
        const filterPanelHeight = filterPanel?.offsetHeight || queryFirst('.refinement-bar .filter-header')?.offsetHeight || 0;
        const offset = childTop + container.scrollTop - (containerTop + filterPanelHeight);
        container.scrollTo({ top: offset, behavior: 'smooth' });
    });
    // }
};
